/*
 * Copyright (C) 2013 Spanning Cloud Apps.  All rights reserved.
 */
import './exportInfo.tpl.html';

angular
  .module('batch.export.info', [
    // including this allows html in the data bound scope properties.
    'ngSanitize',
    'services.view'
  ])
  /**
   * Controller for the batch.info template.
   */
  .controller(
    'ExportInfoCtrl',
    function (
      $scope,
      $filter,
      $state,
      $rootScope,
      $timeout,
      httpBatch,
      batchUtils,
      lastState,
      viewUtils,
      MOBILE_EVENTS,
      BATCH_RESULTS,
      VIEW_STATES
    ) {
      var batchDateTimeFormat = $filter('i18n')('MDY_H_M_12HR'),
        currentBatch = $scope.batchUtils.currentBatch,
        batchDate,
        batchExpirationDate;

      /**
       * Utility function for returning to the previous state.
       */
      $scope.goBack = function () {
        viewUtils.resetState($state.current.name);
        $state.go(lastState || VIEW_STATES.LOG_HOME);
      };

      /**
       * Utility function for returning to the previous state in mobile view.
       */
      $scope.goBackMobile = function () {
        viewUtils.resetState($state.current.name);
        $state.go(lastState || VIEW_STATES.MOBILE_HOME);
      };

      /**
       * Redirect the view to the mobile batch detail view.
       */
      $scope.goToBackupBatchMobile = function () {
        $scope.batchUtils.currentBatch = $scope.originBatch;
        var batchDate = $scope.batchUtils.getTitleBatchDate();
        $rootScope.$emit(MOBILE_EVENTS.HEADER_CHANGE, {
          title: batchDate,
          previous: VIEW_STATES.MOBILE_HOME
        });

        $state.go(VIEW_STATES.MOBILE_BATCH_HOME);
      };

      /**
       * Utility function for showing the backup view.
       */
      $scope.goToBatch = function () {
        // Set the current batch to the retrieved origin batch and
        // show the batch view.
        if ($scope.originBatch) {
          $scope.batchUtils.currentBatch = $scope.originBatch;
          $state.go(VIEW_STATES.BATCH_HOME, { batchId: $scope.originBatch.batchId });
        } else {
          $scope.goBack();
        }
      };

      // If a currentBatch is not set redirect app to the admin view.
      if (_.isEmpty(currentBatch) || !batchUtils.isBatchExportType(currentBatch)) {
        $scope.goBack();
      } else {
        // Go get the batch this export was executed on
        if (currentBatch.exportData.batchId) {
          httpBatch.getBatch(currentBatch.exportData.batchId).then(function (originBatch) {
            $scope.originBatch = originBatch;
            $scope.backupDate = moment(originBatch.date).format(batchDateTimeFormat);
          });
        }

        batchDate = moment(currentBatch.date);
        batchExpirationDate = moment(currentBatch.exportData.expires * 1000);
        $scope.batchDate = $filter('i18n')('BATCH_DETAIL_DATE_EXPORT', [
          batchDate.format(SBSF.messages.M_D_Y),
          batchDate.format(SBSF.messages.H_M),
          currentBatch.type === 'BULK_RESTORE_PREVIEW'
            ? $filter('i18n')('BULK_RESTORE_PREVIEW')
            : $filter('i18n')('EXPORT'),
          currentBatch.status === BATCH_RESULTS.CANCELLED ? $filter('i18n')('CANCELLED_WITH_STYLE') : ''
        ]);

        if (currentBatch.status !== BATCH_RESULTS.SUCCESS) {
          $scope.exportFailed = true;
        } else {
          $scope.exportFailed = false;
          $scope.expireDate = batchExpirationDate.format(batchDateTimeFormat);
          $scope.exportExpired = moment().diff(batchExpirationDate) >= 0;
          $scope.exportSize = $filter('fromBytes')(currentBatch.exportData.size);
          $scope.downloadEvents = currentBatch.downloads;
        }
      }

      // object used to track the difference properties that drive the download table.
      $scope.dlHeaderValues = {
        userName: 'userName',
        date: 'date'
      };
      // property used to order the data in the download table.  It must match one of the keys from the headerValues obj.
      $scope.dlpredicate = $scope.dlHeaderValues.date;
      // direction of the data.
      $scope.dlreverse = true;

      /**
       * Handler for the control to show and hide the error/warning messages.
       */
      $scope.toggleMessages = function () {
        $scope.$parent.showMessages = !$scope.$parent.showMessages;
      };

      /**
       * Handler for the download export button.
       */
      $scope.getDownloadLink = function () {
        var batchId = $scope.batchUtils.currentBatch.batchId;

        if ($scope.downloadLink) {
          window.location = $scope.downloadLink;
        } else if (!$scope.loadingLink) {
          $scope.loadingLink = true;
          $scope.downloadText = $filter('i18n')('LOADING_MSG');

          batchUtils.getDownloadBatchUrl(batchId).then(function (result) {
            $scope.downloadLink = result.url;
            $scope.downloadEvents.push({ userName: result.userName, date: result.date });
            $scope.downloadText = $filter('i18n')('DOWNLOAD_EXPORT', $scope.exportSize);
            $scope.loadingLink = false;
            $timeout(function () {
              $scope.downloadText = $filter('i18n')('REQUEST_DOWNLOAD', $scope.exportSize);
              $scope.downloadLink = null;
            }, 30000);
          });
        }
      };

      /**
       * Function to determine if the button border class should be added.
       * @returns {Boolean} - The flag to add or not add the class.
       */
      $scope.shouldAddBtnBorderCls = function () {
        return $scope.downloadText === $filter('i18n')('REQUEST_DOWNLOAD', $scope.exportSize);
      };

      /*
       * Text for export download
       */
      $scope.downloadText = $filter('i18n')('REQUEST_DOWNLOAD', $scope.exportSize);
    }
  );
